module.exports = __webpack_public_path__ + "static/media/c.15c47d1a.png";